import { 
  GET_PROPOSALS,
  SET_PROPOSAL_SELECTED,
  UPDATE_PROPOSAL,
  CLEAN_PROPOSAL,
  LOAD_PROPOSAL_DATA,
  LOAD_PDF,
} from '../actions/ProposalsAction';
import { SIGN_OUT_USER } from '../actions/AuthUserAction';

const initialState = {
  proposals: {},
  selectedProposal: {},
  newProposalData: {},
};

export default function proposalsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PROPOSALS:
      return {
        ...state,
        proposals: action.data
      }
    case SET_PROPOSAL_SELECTED:
      return {
        ...state,
        selectedProposal: action.data
      }
    case LOAD_PROPOSAL_DATA: 
      return {
        ...state,
        newProposalData: action.data
      }
    case UPDATE_PROPOSAL: 
      return {
        ...state,
        selectedProposal: action.data.item,
        proposals: action.data.list
      }
    case CLEAN_PROPOSAL:
      return {
        ...state,
        selectedProposal: {},
        newProposalData: {},
      }
    case LOAD_PDF: 
      return {
        ...state,
        documentPdf: action.data
      }
    case SIGN_OUT_USER:
      return {}
  
    default:
      return state;
  }
}


